var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 0.6698H2.75C2.042 0.66687 1.3623 0.947149 0.861325 1.44812C0.36035 1.9491 0.080075 2.6288 0.083 3.3368V14.9618C0.0800703 15.6698 0.36035 16.3495 0.861325 16.8505C1.3623 17.3514 2.042 17.6317 2.75 17.6288H18.25C18.958 17.6317 19.6377 17.3514 20.1387 16.8505C20.6397 16.3495 20.9199 15.6698 20.917 14.9618V3.3368C20.9199 2.6288 20.6397 1.9491 20.1387 1.44812C19.6377 0.947149 18.958 0.666875 18.25 0.6698ZM19.458 14.9618C19.458 15.6288 18.917 16.1698 18.25 16.1698H8V2.1288H18.25C18.5703 2.1288 18.8779 2.25575 19.1045 2.48232C19.3311 2.7089 19.458 3.0165 19.458 3.33682L19.458 14.9618Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleSidebarIcon);
export default __webpack_public_path__ + "static/media/toggle-sidebar-icon.3b5b547c4c41d9914baa9752a759e859.svg";
export { ForwardRef as ReactComponent };